import React, {
  createContext,
  useContext,
  useCallback,
  FC,
  ReactNode,
} from "react";
import { useSnackbar } from "notistack";
import { AlertContextType } from "../types";

const AlertContext = createContext<AlertContextType>({
  success: () => {
    console.log("success");
  },
  error: () => {
    console.log("error");
  },
  info: () => {
    console.log("info");
  },
  warning: () => {
    console.log("warning");
  },
});

interface AlertProviderProps {
  children: ReactNode;
}

export const AlertProvider: FC<AlertProviderProps> = ({ children }) => {
  const { enqueueSnackbar } = useSnackbar();

  const success = useCallback(
    (message: string) => {
      enqueueSnackbar(message, { variant: "success" });
    },
    [enqueueSnackbar],
  );

  const error = useCallback(
    (message: string) => {
      enqueueSnackbar(message, { variant: "error" });
    },
    [enqueueSnackbar],
  );

  const info = useCallback(
    (message: string) => {
      enqueueSnackbar(message, { variant: "info" });
    },
    [enqueueSnackbar],
  );

  const warning = useCallback(
    (message: string) => {
      enqueueSnackbar(message, { variant: "warning" });
    },
    [enqueueSnackbar],
  );

  return (
    <AlertContext.Provider value={{ success, error, info, warning }}>
      {children}
    </AlertContext.Provider>
  );
};

export const useAlert = (): AlertContextType => useContext(AlertContext);
